import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  list as listModuleCollaboratingCenters,
  get as getModuleCollaboratingCenter,
  reset as resetModuleCollaboratingCenter,
  update as updateModuleCollaboratingCenter,
  set as setModuleCollaboratingCenter,
  create as createModuleCollaboratingCenter,
  remove as removeModuleCollaboratingCenter,
} from '$redux/collaborating-centers/actions';

import { Button } from '@material-ui/core';
import Title from 'ui/Title';
import Loading from '$routes/Loading';
import Failed from '$routes/Failed';

import Grid from './Grid';
import Editor from './Editor';

class ModuleCollaboratingCenter extends React.Component {
  state = {
    editorOpen: false,
    editorAction: 'new',
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(listModuleCollaboratingCenters());
  }

  onCreate = () => {
    const { dispatch, single } = this.props;
    dispatch(createModuleCollaboratingCenter(single));
  }

  onUpdate = () => {
    const { dispatch, single } = this.props;
    dispatch(updateModuleCollaboratingCenter(single.idCollaboratingCenter, single));
  }

  set = (key, value) => {
    const { dispatch } = this.props;
    dispatch(setModuleCollaboratingCenter(key, value));
  }

  openEditor = (id) => {
    const { dispatch } = this.props;
    if (id) {
      dispatch(getModuleCollaboratingCenter(id));
      this.setState({ editorOpen: true, editorAction: 'edit' });
    } else {
      dispatch(resetModuleCollaboratingCenter());
      this.setState({ editorOpen: true, editorAction: 'new' });
    }
  }

  removeModuleCollaboratingCenter = (id) => {
    const { dispatch } = this.props;
    if (id) {
      dispatch(removeModuleCollaboratingCenter(id));
    }
  }

  render() {
    const { data, single, loading } = this.props;

    if (loading) return <Loading />;
    if (!data) return <Failed />;

    const { editorOpen, editorAction } = this.state;

    return (
      <div>
        <Title>
          Centro Colaboradores
          <Button onClick={() => this.openEditor()} size="small">Crear nuevo centro colaborador</Button>
        </Title>
        {
          editorOpen ? (
            <Editor
              action={editorAction}
              data={single}
              set={this.set}
              onSend={editorAction === 'new' ? this.onCreate : this.onUpdate}
              onClose={() => this.setState({ editorOpen: false })}
            />
          ) : null
        }
        <Grid
          data={data}
          loading={loading}
          onEdit={this.openEditor}
          removeItem={this.removeModuleCollaboratingCenter}
        />
      </div>
    );
  }
}

ModuleCollaboratingCenter.propTypes = {
  dispatch: PropTypes.func.isRequired,
  data: PropTypes.array,
  single: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

ModuleCollaboratingCenter.defaultProps = {
  data: null,
};

export default connect(
  state => ({
    data: state.collaboratingCenters.list,
    single: state.collaboratingCenters.single,
    loading: state.collaboratingCenters.loading,
  }),
)(ModuleCollaboratingCenter);
